export default __webpack_public_path__ + "static/media/minivista_euro6_scania_.10c5aded.jpg";